import { get as lodashGet } from 'lodash'
import { slideType } from '@/constant/allSlideTypes'
import QuizStatuses from '@/constant/QuizStatuses'
import router from '@/router'
import { ROUTE_NAMES } from '@/constant/routes'
import eventCategories from '@/constant/eventCategories'

const RESULT_TOGGLE_BUTTON = 'RESULT_TOGGLE_BUTTON'
const SHOW_SUBMISSION_BUTTON = 'SHOW_SUBMISSION_BUTTON'
const SET_SHOW_CHEATSHEET = 'SET_SHOW_CHEATSHEET'

const ALLOW_SLIDE_TYPES_OF = {
  [RESULT_TOGGLE_BUTTON]: [
    slideType.multipleChoice, slideType.imageChoice, slideType.openEnded,
    slideType.wordCloud, slideType.scale,
  ],
  [SHOW_SUBMISSION_BUTTON]: [
    slideType.multipleChoice, slideType.imageChoice, slideType.openEnded,
    slideType.wordCloud, slideType.scale,
  ],
}

const _state = {
  showCheatsheet: false,
}

const _getters = {
  currentScreen: () => {
    if (!router.currentRoute || !router.currentRoute.name) return null
    if (router.currentRoute.name !== ROUTE_NAMES.PRESENTATION_DETAIL) return null
    let screen = eventCategories.PRESENTING_MODE
    if (router.currentRoute.query && router.currentRoute.query.embedded) {
      screen = eventCategories.PRESENTATION_PREVIEW
    }
    return screen
  },
  presentationId: (_, __, rootState) => lodashGet(rootState, 'presentation.id', null),
  userId: (_, __, rootState) => lodashGet(rootState, 'currentUser.id', null),
  hotKeyTrackingData: (_, getters) => {
    return {
      eventCategory: getters.currentScreen,
      presentationId: getters.presentationId,
      userId: getters.userId,
    }
  },
  slideActiveType: (_, __, rootState) => lodashGet(rootState, 'slideActive.type', ''),
  isQuizLobby: (_, __, rootState) => {
    const { type, quizStatus } = rootState.slideActive
    return type === slideType.pickAnswer && quizStatus === QuizStatuses.LOBBY_SCREEN
  },
  showChat: (_, getters, rootState, rootGetters) => {
    return rootState.presentation.isEnableChat &&
      !rootState.presentation.audiencePacing &&
      !rootState.presentation.privateMode &&
        getters.isQuizLobby &&
        rootGetters.isPresenting &&
        !getters.sharePresentation
  },
  seenCheatsheet: (_, __, rootState) => {
    if (!rootState.currentUser || !rootState.currentUser.personalInformation) return false
    return lodashGet(rootState, 'currentUser.personalInformation.seenCheatsheet', false)
  },
  sharePresentation: (_, __, rootState) => rootState.sharePresentation,
  showResultGroup: (_, getters) => {
    const { sharePresentation, slideActiveType } = getters
    return ALLOW_SLIDE_TYPES_OF[RESULT_TOGGLE_BUTTON].includes(slideActiveType) && !sharePresentation
  },
  showSubmissionGroup: (_, getters) => {
    const { slideActiveType } = getters
    return ALLOW_SLIDE_TYPES_OF[SHOW_SUBMISSION_BUTTON].includes(slideActiveType)
  },
  showCheatsheet: (state) => state.showCheatsheet,
}

const actions = {
  toggleCheatsheetAction({ commit, getters, dispatch }) {
    if (getters.showCheatsheet) {
      commit(SET_SHOW_CHEATSHEET, false)
      return
    }

    commit(SET_SHOW_CHEATSHEET, true)
    if (!getters.seenCheatsheet) {
      dispatch('seenCheatsheetAction')
    }
  },
  hideCheatsheetAction({ commit }) {
    commit(SET_SHOW_CHEATSHEET, false)
  },
  async seenCheatsheetAction({ dispatch, rootState }) {
    const user = rootState.currentUser
    if (!user || !user.id) return
    await dispatch('patchCurrentUserAction', {
      userId: user.id,
      personalInformation: {
        seenCheatsheet: true,
      },
    }, { root: true })
  },
}

const mutations = {
  [SET_SHOW_CHEATSHEET](state, showCheatsheet) {
    state.showCheatsheet = showCheatsheet
  },
}

export const presentationHotKeyModule = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
